import Loadable from 'UIComponents/decorators/Loadable';
const AsyncNotificationSettingsModal = Loadable({
  loader: () => import( /* webpackChunkName: "task-edit-panel-modal" */'./NotificationSettingsModal').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncNotificationSettingsModal;